import loadable from '@loadable/component'

export const SourceOfSupport = loadable(() => import('./SourceOfSupport'))
export type { SourceOfSupportProps } from './SourceOfSupport'
